import React, { Component } from 'react';
class Footer extends Component {
    render(){
        return(
            <div className="footer">
                Created by <a href="https://patmurray.co">Pat Murray</a>. <a href="https://patmurray.co/tip/">Tips are appreciated!</a>. If you like this, please <a href="https://itunes.apple.com/au/app/atlas-wallpaper/id1368484008?mt=8">check out my apps</a>. <br/>Apple and Apple Music are trademarks of Apple Inc., registered in the U.S. and other countries. 
            </div>
        )
    }
}

export default Footer;
